import React from 'react';
import { StyledH1 } from './index.styled';
import { withTranslationText } from '../../hoc/withTranslationText';

export const H1 = withTranslationText(({ renderText, children, ...props }) => (
    <StyledH1 {...props}>{renderText ? renderText : children}</StyledH1>
));
